<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData" label-width="110px" size="mini">
            <el-form-item prop="bmName" class="lable-width" label="部门">
<!--                <el-select clearable class="input-width" v-model="editData.bmName" placeholder="请选择部门">-->
<!--                    <el-option-->
<!--                            v-for="item in this.templateData"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
                <el-select clearable class="input-width" :filter-method="bmfilter" @change="bmchange" v-model="editData.bmName" filterable placeholder="请选择">
                    <el-option
                            v-for="item in bmdata"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
<!--                <el-input class="input-width"  clearable v-model="editData.bmName"></el-input>-->
            </el-form-item>
            <el-form-item prop="cjName" class="lable-width" label="车间">
                <el-select clearable class="input-width" :filter-method="cjfilter" @change="cjchange"  v-model="editData.cjName" filterable placeholder="请选择">
                    <el-option
                            v-for="item in cjdata"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item prop="bzName" class="lable-width" label="班组">-->
<!--&lt;!&ndash;                <el-select clearable class="input-width" v-model="editData.bzName" placeholder="请选择班组">&ndash;&gt;-->
<!--&lt;!&ndash;                    <el-option&ndash;&gt;-->
<!--&lt;!&ndash;                            v-for="item in this.templateData"&ndash;&gt;-->
<!--&lt;!&ndash;                            :key="item.id"&ndash;&gt;-->
<!--&lt;!&ndash;                            :label="item.name"&ndash;&gt;-->
<!--&lt;!&ndash;                            :value="item.id">&ndash;&gt;-->
<!--&lt;!&ndash;                    </el-option>&ndash;&gt;-->
<!--&lt;!&ndash;                </el-select>&ndash;&gt;-->
<!--                <el-select  clearable class="input-width" :filter-method="bzfilter" @change="bzchange"  v-model="editData.bzName" filterable placeholder="请选择">-->
<!--                    <el-option-->
<!--                            v-for="item in bzdata"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--&lt;!&ndash;                <el-input  class="input-width"  clearable v-model="editData.bzName"></el-input>&ndash;&gt;-->
<!--            </el-form-item>-->
            <el-form-item prop="type"  label="轮班类型">

                <el-radio style="margin-left:34px" v-model="editData.type" :label="2">轮班</el-radio>
                <el-radio v-model="editData.type" :label="1">固定</el-radio>
            </el-form-item>
            <el-form-item prop="type"  label="任务类型">

                <el-radio style="margin-left:34px" v-model="editData.taskType" :label="1">生产</el-radio>
                <el-radio v-model="editData.taskType" :label="2">安全</el-radio>
                <el-radio v-model="editData.taskType" :label="3">环保</el-radio>
            </el-form-item>
            <el-form-item prop="type"  label="发布途径">

                <el-radio style="margin-left:34px" v-model="editData.pubType" :label="1">接班</el-radio>
                <el-radio v-model="editData.pubType" :label="2">定时</el-radio>

            </el-form-item>
<!--            <el-form-item v-if="cffb"  class="lable-width" label="间隔时长(h)">-->
<!--                <el-input class="input-width" placeholder="请输入间隔时长" clearable v-model.number="jgsc"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item prop="templateName" class="lable-width" label="岗位">
<!--                <el-select clearable class="input-width" v-model="editData.station" placeholder="请选择岗位">-->
<!--                    <el-option-->
<!--                            v-for="item in this.gwdata"-->
<!--                            :key="item.id"-->
<!--                            :label="item.value"-->
<!--                            :value="item.id">-->
<!--                  </el-option>-->
<!--                </el-select>-->
                <el-select :filter-method="gwsearch"  class="input-width"  @change="gwchange"  filterable   v-model="editData.station">
                    <!--                    <el-option v-for="(val,index) in searchPeople" :key="index" :label="val.name+'('+val.department+')'" :value="val.id"></el-option>-->
                    <el-option v-for="(val,index) in gwdata"  :label="val.name" :value="val.id" :key="val.id"></el-option>

                </el-select>
                <!--                <el-input type="textarea" class="input-width"  clearable v-model="editData.templateName"></el-input>-->
            </el-form-item>
            <el-form-item prop="templateName" class="lable-width" label="模板">
                <el-select clearable class="input-width" v-model="editData.templateName" placeholder="请选择模板">
                    <el-option
                            v-for="item in this.templateData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                    </el-option>
                </el-select>
<!--                <el-input type="textarea" class="input-width"  clearable v-model="editData.templateName"></el-input>-->
            </el-form-item>
            <el-form-item prop="information" class="lable-width" label="信息点">
                <el-input class="input-width" placeholder="请输入信息点" clearable v-model="editData.information"></el-input>
            </el-form-item>
            <el-form-item prop="isNfc"  label="是否NFC">

                <el-radio style="margin-left:34px" v-model="editData.isNfc" :label="1">是</el-radio>
                <el-radio v-model="editData.isNfc" :label="0">否</el-radio>
            </el-form-item>
            <el-form-item prop="nfc" class="lable-width" label="NFC">
                <div style="margin-left: 0px;position: relative">
                    <el-input @focus="nfcfocus" @blur="nfcblur" @change="localradio" class="input-width" label="123" placeholder="请输入"  clearable v-model="editData.nfc"></el-input>
                    <div v-if="nfcopen==1" style="color:#4b36f6;bottom:-23px;left: 30%;text-align: center;font-size: 12px;font-weight: normal;position: absolute">格式：</div>
<!--                    <div v-if="tishi==1&&editData.localtionType=='坐标'" style="color:#4b36f6;bottom:-23px;left: 30%;text-align: center;font-size: 12px;font-weight: normal;position: absolute">格式：x,y</div>-->

                </div>
<!--                <el-input class="input-width"  clearable v-model="editData.localtionType"></el-input>-->
            </el-form-item>
            <el-form-item prop="nfcReal" class="lable-width" label="实际NFC">
                <div style="margin-left: 0px;position: relative">
                    <el-input  @change="localradio1" class="input-width" label="123" placeholder="请输入"  clearable v-model="editData.nfcReal"></el-input>
                    <div v-if="nfcopen==1" style="color:#4b36f6;bottom:-23px;left: 30%;text-align: center;font-size: 12px;font-weight: normal;position: absolute">格式：</div>
                    <!--                    <div v-if="tishi==1&&editData.localtionType=='坐标'" style="color:#4b36f6;bottom:-23px;left: 30%;text-align: center;font-size: 12px;font-weight: normal;position: absolute">格式：x,y</div>-->

                </div>
                <!--                <el-input class="input-width"  clearable v-model="editData.localtionType"></el-input>-->
            </el-form-item>
            <el-form-item  prop="position" class="lable-width" label="坐标位置">
               <div style="position: relative">
                   <el-input @focus="positionfocus" @blur="positionblur" class="input-width" label="123" placeholder="请输入位置"  clearable v-model="editData.position"></el-input>
<!--                   <div v-if="tishi==1&&editData.localtionType=='NFC'" style="color:#4b36f6;bottom:-23px;left: 30%;text-align: center;font-size: 12px;font-weight: normal;position: absolute">格式：</div>-->
                   <div v-if="positionopen==1" style="color:#4b36f6;bottom:-23px;left: 30%;text-align: center;font-size: 12px;font-weight: normal;position: absolute">格式：x,y</div>

               </div>

            </el-form-item>
            <el-form-item prop="photo"  class="lable-width" label="照片数量">
                <el-input class="input-width" placeholder="请输入照片数量" clearable v-model.number="editData.photo"></el-input>
            </el-form-item>
            <el-form-item prop="video"  class="lable-width" label="视频时长(s)">
                <el-input class="input-width" placeholder="请输入视频时长" clearable v-model.number="editData.video"></el-input>
            </el-form-item>
            <el-form-item prop="cycle" class="lable-width" label="任务周期">
                <el-select clearable @change="cycleselect" class="input-width" v-model="editData.cycle" placeholder="请选择任务周期">
                    <el-option
                            v-for="(item,index) in this.cycleData"
                            :key="index"
                            :label="item.lable"
                            :value="item.id">
                    </el-option>
                </el-select>
<!--                <el-input class="input-width"  clearable v-model="editData.cycle"></el-input>-->
            </el-form-item>
            <el-form-item prop="type"  label="是否重复">
                <el-radio-group v-model="editData.isRepeat" @input="cfipt">
                    <el-radio style="margin-left:34px"  :label="1">是</el-radio>
                    <el-radio  :label="0">否</el-radio>
                </el-radio-group>

            </el-form-item>
            <el-form-item v-if="editData.cycle=='Day'&&editData.isRepeat!==1&&!!editData.cycle||editData.cycle==''&&editData.isRepeat!==1&&!!editData.cycle" class="lable-width" label="开始时间">

                <el-time-picker
                        clearable
                        class="input-width"
                        v-model="editData.beginTime"
                        format="HH:mm:ss"
                        value-format="HH:mm:ss"
                        placeholder="请选择">
                </el-time-picker>
                <!--                <el-input class="input-width"  clearable v-model=""></el-input>-->
            </el-form-item>

            <el-form-item style="display: flex" v-if="editData.cycle!=='Day'&&!!editData.cycle"  class="lable-width" label="开始时间">
<!--                <div style="display: flex">-->
                    <el-select style="width: 100px;margin-left: 28px" v-if="editData.cycle=='Week'" clearable  v-model="weekdate" placeholder="请选择">
                        <el-option
                                v-for="item in this.weekData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select style="width: 100px;margin-left: 28px" v-if="editData.cycle=='Month'" clearable  v-model="monthdate" placeholder="请选择">
                        <el-option
                                v-for="(item,index) in this.datatimes"
                                :key="index"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                    <el-time-picker
                            v-if="editData.isRepeat!==1||editData.pubType==2"
                            style="width: 200px;"
                            clearable
                            @change="timepick"
                            v-model="editData.beginTime"
                            format="HH:mm:ss"
                            value-format="HH:mm:ss"
                            placeholder="请选择">
                    </el-time-picker>
<!--                </div>-->

<!--                <el-input class="input-width"  clearable v-model=""></el-input>-->
            </el-form-item>
            <el-form-item style="display: flex" v-if="editData.cycle!=='Day'&&!!editData.cycle&&editData.pubType==2"  class="lable-width" label="结束时间">
                <!--                <div style="display: flex">-->
                <el-select style="width: 100px;margin-left: 28px" v-if="editData.cycle=='Week'" clearable  v-model="endweek" placeholder="请选择">
                    <el-option
                            v-for="item in this.weekData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <el-select style="width: 100px;margin-left: 28px" v-if="editData.cycle=='Month'" clearable  v-model="endmonth" placeholder="请选择">
                    <el-option
                            v-for="(item,index) in this.datatimes"
                            :key="index"
                            :label="item"
                            :value="item">
                    </el-option>
                </el-select>
                <el-time-picker
                        v-if="editData.pubType==2"
                        style="width: 200px;"
                        clearable
                        @change="endtimepick"
                        v-model="editData.endTime"
                        format="HH:mm:ss"
                        value-format="HH:mm:ss"
                        placeholder="请选择">
                </el-time-picker>
                <!--                </div>-->

                <!--                <el-input class="input-width"  clearable v-model=""></el-input>-->
            </el-form-item>

            <el-form-item prop="duration" class="lable-width" label="时长(h)">
                <el-input placeholder="请输入时长" oninput="value=value.replace(/[^0-9.]/g,'')" class="input-width"  clearable v-model="editData.duration"></el-input>
            </el-form-item>
<!--            <el-form-item prop="rate" class="lable-width" label="频率">-->
<!--                <el-input class="input-width" placeholder="请输入频率" clearable v-model.number="editData.rate"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item prop="state" class="lable-width" label="状态">-->
<!--            <el-input class="input-width"  clearable v-model="editData.state"></el-input>-->
<!--        </el-form-item>-->
            <el-form-item prop="lruName" class="lable-width" label="录入人">
                <el-input class="input-width" disabled clearable v-model="editData.lruName"></el-input>
            </el-form-item>
            <el-form-item prop="createTime" class="lable-width" label="录入时间">
                <el-input class="input-width" disabled clearable v-model="editData.createTime"></el-input>
            </el-form-item>

<!--            <el-form-item prop="jsonData" class="lable-width json" label="录入内容模板">-->
<!--                <el-input type="textarea" class="input-width"  clearable v-model="editData.jsonData"></el-input>-->

<!--            </el-form-item>-->
<!--            <el-form-item class="lable-width describe" label="描述">-->
<!--                <el-input  type="textarea"  class="input-width" clearable v-model="editData.describe"></el-input>-->
<!--            </el-form-item>-->
            <!--            <el-form-item  class="slable-width" label="描述">-->
            <!--                <el-input class="sinput-width"  clearable v-model="editData.nextType"></el-input>-->

            <!--            </el-form-item>-->
<!--            <el-form-item class="lable-width" label="录入人">-->
<!--                <el-input class="input-width" disabled clearable v-model="editData.lruName"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item prop="creatTime" class="lable-width" label="创建时间">-->
<!--                <el-input class="input-width"  disabled v-model="editData.creatTime"></el-input>-->

<!--            </el-form-item>-->


            <!--            <el-form-item class="lable-width" label="描述">-->
            <!--                <el-input  type="textarea"  class="input-width" clearable v-model="editData.describe"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item prop="consumerName" class="lable-width" label="消费服务名称">-->
            <!--                <el-select class="input-width" v-model="editData.consumerName" placeholder="请选择消费服务名称">-->
            <!--                    <el-option v-for="val in consumername" :key="val.id" :label="val.name" :value="val.name"></el-option>-->
            <!--                </el-select>-->
            <!--            </el-form-item>-->

            <!--            <el-form-item class="lable-width" label="创建时间">-->
            <!--                <el-input class="input-width" disabled clearable v-model="editData.createTime"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item  label="是否启用">
                <div style="margin-left: 34px">
                    <el-radio v-model="editData.state" @input="ceshi" :label="1">启用</el-radio>
                    <el-radio v-model="editData.state" :label="0">不启用</el-radio>
                </div>
            </el-form-item>
            <!--            <el-form-item  label="是否继续">-->
            <!--                <div style="margin-left: 46px">-->
            <!--                    <el-radio v-model="editData.isNext" :label="1">是</el-radio>-->
            <!--                    <el-radio v-model="editData.isNext" :label="0">否</el-radio>-->
            <!--                </div>-->
            <!--            </el-form-item>-->
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit(editData)">保存</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'reviseTemplate',
        props:{

            editData:{
                type:Object
            }
        },
        data(){
            return{
                cf:'',
                cffb:false,
                jgsc:'',
                gwcgdata:999,
                bmdata:[],
                cjdata:[],
                bzdata:[],
                gwdata:[
                //     {
                //     id:1,
                //     value:'厂长'
                // },{
                //     id:2,
                //     value:'班长'
                // },{
                //     id:3,
                //     value:'卸料'
                // },{
                //     id:4,
                //     value:'成盐'
                // },{
                //     id:5,
                //     value:'缩合'
                // },{
                //     id:6,
                //     value:'浓缩'
                // },{
                //     id:7,
                //     value:'中控'
                // },{
                //     id:8,
                //     value:'小组长'
                // },{
                //     id:9,
                //     value:'商水班长'
                // },{
                //     id:10,
                //     value:'商水叉车'
                // },{
                //     id:11,
                //     value:'商水操作工'
                // },
        ],
                value:'',
                weekdate:'',
                // gwdata:[],
                // stationdata:[],
                monthdate:'',
                positionopen:0,
                nfcopen:0,
                cycleData:[{
                    id:'Day',
                    lable:'每日'
                },{
                    id:'Week',
                    lable:'每周'
                },{
                    id:'Month',
                    lable:'每月'
                },],
                endweek:[],
                endmonth:[],
                weekData:[{
                    id:1,
                    name:'星期一'
                },{
                    id:2,
                    name:'星期二'
                },{
                    id:3,
                    name:'星期三'
                },{
                    id:4,
                    name:'星期四'
                },{
                    id:5,
                    name:'星期五'
                },{
                    id:6,
                    name:'星期六'
                },{
                    id:7,
                    name:'星期七'
                },],
                monthData:[],
                consumername:[],
                datatimes:[],
                templateData:[],
                cjpanduan:0,
                bzpanduan:0,
                rules: {
                    // bmName: [
                    //     { required: true, message: '请输入部门', trigger: 'blur' },
                    //
                    // ],
                    // cjName: [
                    //     { required: true, message: '请输入车间', trigger: 'blur' },
                    //
                    // ],
                    //
                    // templateName: [
                    //     { required: true, message: '请输入模板', trigger: 'blur' },
                    //
                    // ],
                    // information: [
                    //     { required: true, message: '请输入信息点', trigger: 'blur' },
                    //
                    // ],
                    //
                    // cycle: [
                    //     { required: true, message: '请输入任务周期', trigger: 'blur' },
                    //
                    // ],
                    //
                    // duration: [
                    //     { required: true, message: '请输入时长', trigger: 'blur' },
                    //
                    // ],



                }
            }
        },
        watch:{
        },
        mounted(){

            // if(this.editData.beginTime!==''){
            // console.log()


                // console.log(this.weekData[a-1])
            // }
            this.getDepartmentsList()
            this.getTemplatesDropdownList()
            this.getStationsList()
            // this.datatimes = [];
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let d = new Date(year, month, 0);
            let n = +d.getDate();

            for (var i = 1; i <=28; i++) {
                if(i<10){
                    i='0'+i
                }
                this.datatimes.push(i);
            }

            // console.log(this.editData.beginTime)

            if(this.editData.cycle=='Week'){

                // if(this.editData.beginTime.length<5){
                if(!!this.editData.beginTime) {
                    let a=this.editData.beginTime.substring(0,1)
                    this.weekdate=this.weekData[a-1].id
                    if(this.editData.isRepeat==1&&this.editData.pubType!==2){
                        this.editData.beginTime=''

                    }else{
                        console.log(this.editData.beginTime.substring(2,this.editData.beginTime.length))
                        this.editData.beginTime=this.editData.beginTime.substring(2,this.editData.beginTime.length).trim()
                    }
                }

                if(this.editData.endTime!==''){
                    let enda=this.editData.endTime.substring(0,1)
                    this.endweek=this.weekData[enda-1].id
                    if(this.editData.pubType==2){
                        this.editData.endTime=this.editData.endTime.substring(2,this.editData.endTime.length).trim()

                    }else{
                        this.editData.endTime=''

                    }
                }



                // }
                // console.log(this.weekdate,this.editData.beginTime.substring(0,1))
            }else if(this.editData.cycle=='Month'){

                // if(this.editData.beginTime.trim().length<5){
                //     this.editData.beginTime=''
                // console.log(this.editData.beginTime.substring(0,1))
                    // if(this.editData.beginTime.substring(0,1)=='0') {
                if(!!this.editData.beginTime){
                    var b = this.editData.beginTime.substring(0, 2)
                    if(this.editData.isRepeat==1&&this.editData.pubType!==2){
                        this.editData.beginTime=''

                    }else{
                        this.editData.beginTime=this.editData.beginTime.substring(2,this.editData.beginTime.length).trim()
                    }

                    // }else{
                    //     var b = this.editData.beginTime.substring(0, 1)
                    //
                    // }
                    // console.log(b)
                    if(b.substring(0,1)=='0'){
                        b=parseFloat(b.substring(1,2))
                    }else{
                        b=parseFloat(b)
                    }


                    // console.log(b,this.datatimes)
                    this.monthdate=this.datatimes[b-1]
                }
                if(this.editData.endTime!=='') {
                    var c = this.editData.endTime.substring(0, 2)
                    if(this.editData.pubType==2){
                        this.editData.endTime=this.editData.endTime.substring(2,this.editData.endTime.length).trim()

                    }else{
                        this.editData.endTime=''

                    }
                    if(c.substring(0,1)=='0'){
                        c=parseFloat(c.substring(1,2))
                    }else{
                        c=parseFloat(c)
                    }
                    this.endmonth=this.datatimes[c-1]
                }

                // }

                // console.log(this.monthdate,this.editData.beginTime.substring(0,1))

                // console.log(this.datatimes[b-1],b)
            }
            // if(this.editData.rate=='a'){
            //     this.editData.rate=1
            // }
            // if(this.editData.cjName!==''){
            //     this.editData.cjName=
            // }
            // if(this.editData.bmName!==''){
            //
            // }
            // if(this.editData.id!==0){
            //     this.
            // }
            // console.log(this.editData.beginTime.length)
            // if(this.editData.id!==0){
            //     // this.editData.id=1
            // }
        },
        methods:{
            ceshi(e){
              console.log(e,1)
            },
            bmfilter(val){
                // this.editData.bmName=val
                this.getDepartmentsList(val)
                // console.log(this.editData.bmName)
            },
            // gwfilter(val){
            //     this.getStationsList(val)
            // },
            gwsearch(val){
                // this.editData.sid=val
            this.getStationsList(val)
            },
            gwchange(val){
                this.editData.station=val
                // console.log(val)
            },
            cjfilter(val){
                // console.log(val)
                if(this.editData.bmName!==''){
                    this.getWorkshopsList(val)

                }

            },
            cfipt(e){
                // if(e==1){
                //     this.cffb=!this.cffb
                //     // this.editData.beginTime
                // }else{
                //     this.cffb=!this.cffb
                //
                // }
                // console.log(e)
            },
            bzfilter(val){
                // if(this.editData.cjName!=='') {
                //
                //     this.getTeamsList(val)
                // }
            },
            bmchange(val){
                this.editData.gid=val
                if(this.editData.bmName!==''){
                    this.getWorkshopsList()
                }
                this.editData.cjName=''
                // this.editData.bzName=''
            },
            cjchange(val){
                this.editData.cid=val

                // if(this.editData.cjName!==''){
                //     this.getTeamsList()
                //
                // }
            },
            bzchange(val){
                this.editData.bid=val
                // if(this.editData.cjName!=='') {
                //
                //     this.getTeamsList()
                // }
            },
            nfcfocus(){
                this.nfcopen=1
            },
            positionfocus(){
                this.positionopen=1

            },
            nfcblur(){
                this.nfcopen=0
            },
            positionblur(){
                this.positionopen=0
            },
            timepick(val){
                if(val==null){
                   // this.editData.startTime

                    this.editData.beginTime=''
                }
            },
            endtimepick(val){
                if(val==null){
                    // this.editData.startTime

                    this.editData.endTime=''
                }
            },
            cycleselect(val){
                this.editData.cycle=val

                // if(val==''){
                    this.editData.beginTime=''
                this.editData.endTime=''
                this.endweek=''
                this.endmonth=''
                // }
                this.monthdate=''
                this.weekdate=''
                // console.log(this.datatimes)
            },
            radiojudge(val){

            },
            localradio(val){
                // console.log(val)
                this.editData.nfc=val
                // this.tishi=1
            },
            localradio1(val){
                // console.log(val)
                this.editData.nfcReal=val
                // this.tishi=1
            },
            ...mapActions(["getCurrentMenuId"]),

            //部门
            async getDepartmentsList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:val
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getDepartmentsList(params);
                if (res.code == 1) {
                    this.bmdata=res.departmentsList
                    // console.log(this.editData.gid==undefined)
                    if(this.editData.gid!==undefined){
                        this.getWorkshopsList()

                    }

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //车间
            async getWorkshopsList(val) {
                // console.log(this.editData.bmName)

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:val,
                    pid:this.editData.gid
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getWorkshopsList(params);
                if (res.code == 1) {
                    this.cjdata=res.workshopsList
                    // if(this.editData.cid!==undefined){
                    //     this.getTeamsList()
                    //
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //岗位
            async getStationsList(val) {
                // console.log(this.editData.bmName)

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:val,
                    // pid:this.editData.bmName
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getStationsList(params);
                if (res.code == 1) {
                    this.gwdata=res.stationsList
                    // console.log(this.gwdata)
                    // if(this.editData.cjName!==''){
                    //     this.getTeamsList()
                    //
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //班组
            async getTeamsList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:val,
                    pid:this.editData.cid
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getTeamsList(params);
                if (res.code == 1) {
                    // this.bzdata=res.teamsList

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //模板
            async getTemplatesDropdownList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {

                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getTemplatesDropdownList(params);
                if (res.code == 1) {
                    this.templateData=res.list

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //业务配置保存
            async saveTask() {
                if(this.editData.isRepeat==1&&this.editData.pubType!==2){
                    this.editData.beginTime=''
                }
                if(this.editData.pubType==1){
                    this.editData.endTime=''
                }
                this.gwdata.filter(item=>{
                    // console.log(item.name)
                    if(this.editData.station==item.name){
                        this.editData.station=item.id
                    }
                })
                // console.log(this.editData.station)
                // return
                if(parseFloat(this.editData.video)<=60&&parseFloat(this.editData.video)>=0){

                }else {
                    this.$message({
                        message: '请输入60秒以内的时长',
                        type: 'warning'
                    });
                    return
                }

                // if(parseFloat(this.editData.duration)>24||parseFloat(this.editData.duration)<0){
                //     this.$message({
                //         message: '请输入24小时以内的时长',
                //         type: 'warning'
                //     });
                //     return
                // }
                if(!this.editData.duration){
                    this.$message({
                        message: '请输入时长',
                        type: 'warning'
                    });
                    return
                }
                if(!this.editData.cycle){
                    this.$message({
                        message: '请选择周期',
                        type: 'warning'
                    });
                    return
                }
                if(this.editData.cycle=='Day'){
                    this.editData.startTime=this.editData.beginTime
                    // if(this.editData.beginTime==''&&this.editData.isRepeat!==1){
                    //     this.$message({
                    //         message:'请选择时间后保存',
                    //         type:'warning'
                    //     })
                    //     return
                    // }
                }
                if(this.editData.cycle=='Week'&&this.editData.id!==0){
                    if(!this.weekdate){
                        this.$message({
                            message:'请选择日期后保存',
                            type:'warning'
                        })
                        return
                    }
//                     if(this.weekdate==''||this.editData.beginTime==''&&this.editData.isRepeat!==1){
//                         // if(this.weekdate==''){
//                         //     this.$message({
//                         //         message:'请选择开始日期后保存',
//                         //         type:'warning'
//                         //     })
//                         //     return
//                         // }
//                         // else if(this.editData.beginTime==''&&this.editData.isRepeat!==1){
//                         //     this.$message({
//                         //         message:'请选择开始时间后保存',
//                         //         type:'warning'
//                         //     })
//                         //     return
//                         // }
//
//                         // console.log(1)
// // return
//                     }else{
                        // console.log(this.editData.beginTime)
                        this.editData.startTime=''
                        if(this.editData.isRepeat==1&&this.editData.pubType==1){
                            this.editData.beginTime=''
                        }
                        this.editData.startTime=this.weekdate+' '+this.editData.beginTime
                            // .replace(/\s+/g,'').substring(1,this.editData.beginTime.length)

                    // }
                    // console.log(this.editData.pubType)
                    if(this.editData.pubType==2){
                        this.editData.overTime=''
                        if(this.editData.pubType==1){
                            this.editData.endTime=''
                            this.endweek=''
                        }
                        // console.log(this.editData.startTime)
                        // console.log(this.weekdate)
                        // console.log(this.endweek)
                        this.editData.overTime=this.endweek+' '+this.editData.endTime
                        // console.log(this.editData.overTime)

                        if(this.endweek==''){
                            this.$message({
                                message:'请选择结束日期后保存',
                                type:'warning'
                            })
                            return
                        }
                        // else if(this.editData.endTime==''){
                        //     this.$message({
                        //         message:'请选择结束时间后保存',
                        //         type:'warning'
                        //     })
                        //     return
                        // }
                    }else{

                    }
                } else if(this.editData.cycle=='Week'&&this.editData.id==0){
                    if(!this.weekdate){
                        this.$message({
                            message:'请选择日期后保存',
                            type:'warning'
                        })
                        return
                    }
                    // if(this.weekdate==''||this.editData.beginTime==''&&this.editData.isRepeat!==1){
                    //     // if(this.weekdate==''){
                    //     //     this.$message({
                    //     //         message:'请选择开始日期后保存',
                    //     //         type:'warning'
                    //     //     })
                    //     //     return
                    //     // }
                    //     // else if(this.editData.beginTime==''&&this.editData.isRepeat!==1){
                    //     //     this.$message({
                    //     //         message:'请选择开始时间后保存',
                    //     //         type:'warning'
                    //     //     })
                    //     //     return
                    //     // }
                    //     // return
                    // }else {
                        this.editData.startTime=''

                        this.editData.startTime=this.weekdate+' '+this.editData.beginTime
                        // console.log(this.editData.startTime)
                        // return
                    // }
                    if(this.editData.pubType==2){
                        this.editData.overTime=''

                        this.editData.overTime=this.endweek+' '+this.editData.endTime
                        if(this.endweek==''){
                            this.$message({
                                message:'请选择结束日期后保存',
                                type:'warning'
                            })
                            return
                        }
                        // else if(this.editData.endTime==''){
                        //     this.$message({
                        //         message:'请选择结束时间后保存',
                        //         type:'warning'
                        //     })
                        //     return
                        // }
                    }else{

                    }
                }
                if(this.editData.cycle=='Month'&&this.editData.id!==0){
                    if(!this.monthdate){
                        this.$message({
                            message:'请选择日期后保存',
                            type:'warning'
                        })
                        return
                    }
                    // if(this.monthdate==''){
                        // console.log(3)
                        // if(this.monthdate==''){
                        //     this.$message({
                        //         message:'请选择开始日期后保存',
                        //         type:'warning'
                        //     })
                        //     return
                        // }
                        // else if(this.editData.beginTime==''&&this.editData.isRepeat!==1){
                        //     this.$message({
                        //         message:'请选择开始时间后保存',
                        //         type:'warning'
                        //     })
                        //     return
                        // }
                        // return
                    // }else{

                        this.editData.startTime=''
                        if(this.editData.isRepeat==1&&this.editData.pubType==1){
                            this.editData.beginTime=''
                        }

                        this.editData.startTime=this.monthdate+' '+this.editData.beginTime

                            // .replace(/\s+/g,'').substring(1,this.editData.beginTime.length)

                    // }
                    if(this.editData.pubType==2){
                        this.editData.overTime=''
                        if(this.editData.pubType==1){
                            this.editData.endTime=''
                            this.endmonth=''
                        }
                        this.editData.overTime=this.endmonth+' '+this.editData.endTime
                        if(!this.endmonth){
                            this.$message({
                                message:'请选择结束日期后保存',
                                type:'warning'
                            })
                            return
                        }
                        // else if(this.editData.endTime==''){
                        //     this.$message({
                        //         message:'请选择结束时间后保存',
                        //         type:'warning'
                        //     })
                        //     return
                        // }
                    }
                    // this.editData.beginTime=th   is.monthdate+' '+this.editData.beginTime

                }else if(this.editData.cycle=='Month'&&this.editData.id==0){
                    if(!this.monthdate){
                            this.$message({
                                message:'请选择日期后保存',
                                type:'warning'
                            })
                            return
                    }
                    // if(this.monthdate==''||this.editData.beginTime==''&&this.editData.isRepeat!==1){
                        // console.log(4)
                        // if(this.monthdate==''){
                        //     this.$message({
                        //         message:'请选择日期后保存',
                        //         type:'warning'
                        //     })
                        //     return
                        // }
                        // else if(this.editData.beginTime==''&&this.editData.isRepeat!==1){
                        //     this.$message({
                        //         message:'请选择时间后保存',
                        //         type:'warning'
                        //     })
                        //     return
                        // }
                        // return
                    // }else{
                        this.editData.startTime=''

                        this.editData.startTime=this.monthdate+' '+this.editData.beginTime
                        // console.log(this.editData.startTime)
                        // return
                    // }
                    if(this.editData.pubType==2){
                        this.editData.overTime=''

                        this.editData.overTime=this.endmonth+' '+this.editData.endTime
                        if(!this.endmonth) {
                            this.$message({
                                message: '请选择结束日期后保存',
                                type: 'warning'
                            })
                            return
                        }
                        // }else if(this.editData.endTime==''){
                        //     this.$message({
                        //         message:'请选择结束时间后保存',
                        //         type:'warning'
                        //     })
                        //     return
                        // }
                    }else{

                    }
                }
                // console.log(this.editData.templateName)
                if(this.editData.templateName!==''){
                    let add=this.templateData.filter(item=>{
                        return item.name==this.editData.templateName
                    })
                    var templateid=add[0].id
                }else {
                    var templateid=0

                }
                // if(this.editData.cycle=='Week'&&this.editData.pubType==2&&!!this.endweek){
                //     if(this.endweek<=this.weekdate){
                //         this.$message({
                //             message:'结束日期需大于开始日期',
                //             type:'warning'
                //         })
                //         return
                //     }
                // }
                // if(this.editData.cycle=='Month'&&this.editData.pubType==2&&!!this.endmonth){
                //     if(parseFloat(this.endmonth)<=parseFloat(this.monthdate)){
                //         this.$message({
                //             message:'结束日期需大于开始日期',
                //             type:'warning'
                //         })
                //         return
                //     }
                // }
                if(this.editData.cycle=='Week'){
                    if(!!this.editData.beginTime&&!this.weekdate){
                        this.$message({
                            message:'请选择日期',
                            type:'warning'
                        })
                        return
                    }
                    if(!!this.editData.endTime&&!this.endweek){
                        this.$message({
                            message:'请选择日期',
                            type:'warning'
                        })
                        return
                    }
                }
                if(this.editData.cycle=='Month'){
                    if(!!this.editData.beginTime&&!this.monthdate){
                        this.$message({
                            message:'请选择日期',
                            type:'warning'
                        })
                        return
                    }
                    if(!!this.editData.endTime&&!this.endmonth){
                        this.$message({
                            message:'请选择日期',
                            type:'warning'
                        })
                        return
                    }
                }
                console.log(this.editData.startTime)
                console.log(this.editData.overTime)
                // return
                // console.log(this.endweek,this.weekdate)
                // this.weekdate.filter(item=>{
                //
                // })
                // if()
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    gid:this.editData.gid,//部门
                    cid:this.editData.cid,//车间
                    // bid:this.editData.bid,//班组
                    // sid:this.editData.sid,
                    // rate:this.editData.rate,
                    isNfc:this.editData.isNfc,
                    tid:templateid,
                    taskType:this.editData.taskType,
                    pubType:this.editData.pubType,
                    isRepeat:this.editData.isRepeat,
                    // tid:this.editData.templateName,
                    information:this.editData.information,
                    nfc:!this.editData.nfc?'':this.editData.nfc,
                    nfcReal:this.editData.nfcReal,
                    position:this.editData.position,
                    photo:parseFloat(this.editData.photo),
                    video:parseFloat(this.editData.video),
                    cycle:this.editData.cycle,
                    station:this.editData.station,
                    beginTime:!!this.editData.startTime?this.editData.startTime:'',
                    endTime:this.editData.pubType==1?'':this.editData.overTime,
                    duration:parseFloat(this.editData.duration),
                    creatTime:this.editData.creatTime,
                    lruid:parseFloat(sessionStorage.getItem("userid")) ,
                    lruName:sessionStorage.getItem('lruname'),
                    state:parseFloat(this.editData.state) ,
                    // isNext:this.editData.isNext
                    type:this.editData.type
                }
                // console.log(params)
                // return
                let res = await API.saveTask(params);
                if (res.code == 1) {
                    this.$emit('getTasksList')
                    this.$emit('close')
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });

                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else if (res.code == -1){
                        this.editData.beginTime=''
                    this.endmonth=''
                    this.endweek=''
                    this.editData.endTime=''
                    this.$message({
                        message:res.message,
                        type:'warning'
                    })
                }else {
                    this.editData.endTime=''
                    this.endmonth=''
                    this.endweek=''
                    this.editData.beginTime=''
                    this.$message.error(res.message);

                }
            },
            close(){
                this.$emit('close')
            },

            onSubmit(editData){
//获取对应ID
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        // console.log(this.editData.xfname)

                        // let add1=this.consumername.filter(item=>{
                        //     return  item.name==this.editData.consumerName
                        // })
                        // console.log(add1)
                        // this.editData.consumerId=add1[0].id
                        this.saveTask()
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });


            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>